import(/* webpackMode: "eager" */ "/app/app/nfl/scores/[[...week]]/error.tsx");
